import { render, staticRenderFns } from "./TruckIcon.vue?vue&type=template&id=6ba057ce&"
import script from "./TruckIcon.vue?vue&type=script&lang=js&"
export * from "./TruckIcon.vue?vue&type=script&lang=js&"
import style0 from "./TruckIcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports